"use strict";
"use client";
import { SegmentGroup } from '@ark-ui/react/segment-group';
import { createSlotRecipeContext } from '../../styled-system/create-slot-recipe-context.js';

const {
  withProvider,
  withContext,
  useStyles: useSegmentGroupStyles,
  PropsProvider
} = createSlotRecipeContext({ key: "segmentGroup" });
const SegmentGroupRootProvider = withProvider(SegmentGroup.RootProvider, "root", { forwardAsChild: true });
const SegmentGroupRoot = withProvider(SegmentGroup.Root, "root", { forwardAsChild: true });
const SegmentGroupPropsProvider = PropsProvider;
const SegmentGroupItem = withContext(SegmentGroup.Item, "item", { forwardAsChild: true });
const SegmentGroupItemText = withContext(SegmentGroup.ItemText, "itemText", { forwardAsChild: true });
const SegmentGroupIndicator = withContext(SegmentGroup.Indicator, "indicator", { forwardAsChild: true });
const SegmentGroupItemHiddenInput = SegmentGroup.ItemHiddenInput;
const SegmentGroupContext = SegmentGroup.Context;
const SegmentGroupItemContext = SegmentGroup.ItemContext;

export { SegmentGroupContext, SegmentGroupIndicator, SegmentGroupItem, SegmentGroupItemContext, SegmentGroupItemHiddenInput, SegmentGroupItemText, SegmentGroupPropsProvider, SegmentGroupRoot, SegmentGroupRootProvider, useSegmentGroupStyles };
